import { clsx } from "@trydig/ui";
import Image from "next/image";
import { sizes } from "@/components/bloks/Asset";
import { Skeleton } from "@/components/ui/Skeleton";
import styles from "./ProductImage.module.css";

export const ProductImage = ({
	src,
	priority,
	className,
}: {
	src: string;
	priority?: boolean;
	className?: string;
}) => {
	return (
		<div className={clsx(styles.root, className)}>
			<Image
				priority={priority}
				sizes={sizes(100, 45)}
				quality={90}
				fill
				src={src}
				alt=""
			/>
		</div>
	);
};

export const ProductImageSkeleton = ({ className }: { className?: string }) => {
	return <Skeleton className={clsx(styles.root, className)} />;
};
